import React, { useState, forwardRef } from 'react';
import styles from './GlobalInput.module.css';

export interface GlobalInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  showErrorText?: boolean;
}

export const GlobalInput = forwardRef<HTMLInputElement, GlobalInputProps>(
  ({ label, error, className, value, disabled, showErrorText = true, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const hasValue =
      value !== undefined && value !== null
        ? String(value).length > 0
        : false;

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      if (!disabled) {
        setIsFocused(true);
        props.onFocus?.(e);
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      props.onBlur?.(e);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!disabled) {
        props.onChange?.(e);
      }
    };

    return (
      <div className={`${styles.inputContainer} ${disabled ? styles.disabled : ''} ${className || ''}`}>
        <div className={`${styles.inputWrapper} ${disabled ? styles.wrapperDisabled : ''}`}>
          <input
            {...props}
            ref={ref}
            value={value}
            disabled={disabled}
            className={`${styles.input} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.inputDisabled : ''}`}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder=" "
          />
          <label className={styles.label}>{label}</label>
        </div>
        {error && showErrorText && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

GlobalInput.displayName = 'GlobalInput';
